import logo from "assets/img/logo/logo_aig_login-2.png";
import Page from "components/Page";
import Moment from "moment";
import React from "react";
import axios from "axios";
import { Growl } from "primereact/growl";
import { FetchPost } from "../../redux/actions/api";
import "react-datepicker/dist/react-datepicker.css";
import LoadingScreen from "react-loading-screen";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Alert, Button, Card, CardBody, CardImg, Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, Label, } from "reactstrap";
import { ambienteAplicacion, urlPlaceToPayKm, urlFVinculacion, urlGenerarPago, urlGuardarCodigoCuotas } from "../../constants/urls";
import publicIp from "public-ip";
import { tramaSuscripcionTarjetaP2P } from "../../constants/tramas/tramasPago";
import { FetchDataProductosCarrito } from "../../redux/actions/ACarritoProductos";
import { Checkbox } from "react-inputs-validation";
import Select1 from 'react-select';
import {
  FetchGuardarDatosFacturacion,
  FetchGuardarFormaPago,
  FetchGuardarFormaPagoRenovaciones,
  FetchLimpiarUrlPlacetoPay,
  FetchObtenerFormasPago,
  FetchObtenerUrlPlacetoPay,
  FetchValidarPagoPendiente,
  obtenerDatosClienteFetch,
  recuperarDatosFacturacionFetch,
} from "../../redux/actions/aCotizacion";
import datosFacturacion from "../datosFacturacion/datosFacturacion";
import { datosCotizacion } from "../../redux/reducers/rCotizacion";
import { suscripcionExternaTarjetaP2P } from "../../redux/actions/aPagos";
import { consultarUsuarioFV, setConsultarUsuarioFv } from "../../redux/actions/aFormularioVinculacion";
import { datosPagadorFormato } from "../../helpers/helpersFacturacion";
import { empresa, plataformaWeb } from "../../constants/index";
import { getTituloFv } from "../../helpers/helpersFV";
import { FetchDataBancosCuotas } from "../../redux/actions/APolizas";
import { apiGet } from "../../api";
Moment.locale("es");

class CotizacionFormaPago extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      verPagos:
        this.props.datosPago.datosPagar.pagopendiente === undefined
          ? true
          : this.props.datosPago.datosPagar.pagopendiente,
      idCarrito: this.props.dataFacturacion.datosFacturacion.idCarrito
        ? this.props.dataFacturacion.datosFacturacion.idCarrito
        : "",
      ambiente: this.props.dataFacturacion.datosFacturacion.ambiente
        ? this.props.dataFacturacion.datosFacturacion.ambiente
        : "",
      dpago: [],
      loadign: false,
      /*ES */
      tipoCotizador: null,
      FormasPago: [],
      openModal: false,
      errorEnvio: false,
      cuotas: 1,
      cuotaSeleccionada: null,
      bancoSeleccionado: null,
      codigoBanco: null,
      arrayCuotas: [],
      submitFormularioBancos: false,
      errorFormularioBancos: false,
      errorFormularioCuotas: false,
      utilizarMismaTarjeta: false,
      ultimosDigitos: ""
    };
    this.transaccionPendiente = this.transaccionPendiente.bind(this);
    this.ObtenerUrlRedireccionar = this.ObtenerUrlRedireccionar.bind(this);
    this.SeleccionarFormaPago = this.SeleccionarFormaPago.bind(this);
    this.SuscripcionTarjetaP2P = this.SuscripcionTarjetaP2P.bind(this);
  }

  // suscribir tarjeta p2p
  async SuscripcionTarjetaP2P() {
    // datos del pagador
    const pagador = this.props.datosCotizacion.datosPagador;
    const idPoliza = this.props.dataFacturacion.datosAdicionales.idPoliza;
    const nombre = pagador.cliNombres;
    const apellido = pagador.cliApellidos;
    const email = pagador.cliEmail;
    const identificacion = pagador.cliIdentificacion;
    const tipoDocumento = pagador.cliCodigoTipoDocumento === '1' ? 'CI' : (pagador.cliCodigoTipoDocumento === '2' ? 'RUC' : 'PAS');
    const celular = pagador.cliCelular;
    let cliIp = '';
    await publicIp.v4().then(
      ip => cliIp = ip
    );

    // body post
    const body = tramaSuscripcionTarjetaP2P({
      idPoliza, nombre, apellido, email, identificacion, tipoDocumento, celular, cliIp
    });

    // consultar servicio para redireccion
    await this.props.suscripcionP2P(body);
    console.log('placeToPay', body, this.props.placetoPay);
    window.location.href = this.props.placetoPay.suscripcionTarjetaP2PResponse.traUrl;
    // this.props.history.push({
    //   pathname: this.props.placetoPay.suscripcionTarjetaP2PResponse.traUrl
    // })
  }

  openModal = (value) => {
    this.setState({ openModal: value });
  };
  submitFormulario = async (forma) => {
    this.setState({ submitFormularioBancos: true })
    if (this.state.bancoSeleccionado == null) {
      this.setState({ errorFormularioBancos: true })
    } else {
      this.setState({ errorFormularioBancos: false })
    }

    if (this.state.cuotaSeleccionada == null) {
      this.setState({ errorFormularioCuotas: true })
    } else {
      this.setState({ errorFormularioCuotas: false })
    }

    if (this.state.bancoSeleccionado != null && this.state.cuotaSeleccionada != null) {

      this.SeleccionarFormaPago(
        null,
        forma,
        true
      )

    }

  };
  enviarCorreo = async () => {
    this.setState({ loadign: true, openModal: false })

    console.log("ingreso a generar");
    var url = `${urlGenerarPago}${this.props.dataFacturacion.datosAdicionales.idPoliza}`;

    await fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {

        this.setState({ loadign: false })

        console.log('datita', data)


        if (data.transaccion) {
          this.showWarn(data.alerta, 'info')

          setTimeout(() => {


          }, 2000);

        } else {
          this.showWarn(data.alerta, 'warn')

        }



      })
      .catch((response) => {
        console.log('error')
        this.setState({ loadign: false, errorEnvio: true })
      });

  }


  async SeleccionarFormaPago(e, forma, suscripcion) {
    this.setState({ loadign: true });

    const PagoJSON = {
      empresa: empresa,
      plataforma: plataformaWeb,
      idCarrito: this.props.dataFacturacion.datosFacturacion.idCarrito,
      formCodigo: forma,
      idConducto: "",
      idPlanPago: "",
    };


    await this.props.guardarFormaPago(PagoJSON);
    //debugger
    if (!this.props.datosGuardarFormaPago.guardarFormaPagoHasError) {

      if (suscripcion) {
        await apiGet(`${urlGuardarCodigoCuotas}${this.props.dataFacturacion.datosFacturacion.idCarrito}&cuotas=${this.state.cuotaSeleccionada.value}&codigoBanco=${this.state.bancoSeleccionado.value}&mismaTarjeta=${this.state.utilizarMismaTarjeta}`)

        this.enviarCorreo()
      }
      if (
        this.props.dataFacturacion.datosFacturacion &&
        this.props.dataFacturacion.datosFacturacion
          .redireccionarPantallaIngresoIdentificaciones &&
        this.props.dataFacturacion.datosFacturacion
          .redireccionarPantallaIngresoIdentificaciones === true
      ) {
        this.props.history.push({
          pathname: "/cotizacion-hogar-identificaciones",
          search: `?id=${this.props.dataFacturacion.datosFacturacion.idCarrito}`,
        });
      } else {
        // let resp = await FetchPost({
        //   url: urlFVinculacion+this.props.dataFacturacion.datosFacturacion.idCarrito,
        //   param:''
        // });

        await this.props.consultarFv({ content: '', id: this.props.dataFacturacion.datosFacturacion.idCarrito });
        console.log('testingd', this.props.formularioVinculacion);
        const { transaccion, pasarPantallaFormulario, urlFormulario } = this.props.formularioVinculacion.usuarioFv;

        if (transaccion) {
          let titulo = '';
          if (pasarPantallaFormulario) {
            this.props.history.push({
              pathname: "/formulario-vinculacion-renovacion",
              search: `?url=${urlFormulario}&id=${this.props.dataFacturacion.datosFacturacion.idCarrito}`,
            });
          }
          else {
            const descripcionRamo = this.props.dataFacturacion.datosFacturacion.carDescripcionRamo;
            const descripcionSeguro = this.props.dataFacturacion.datosFacturacion.carDescripcionSeguro;
            titulo = getTituloFv(descripcionRamo, descripcionSeguro);
            console.log("/formulario-vinculacion1");
            this.props.history.push({
              pathname: "/formulario-vinculacion-renovacion",
              search: `?haveForm=${titulo}`,
            });
            console.log("/formulario-vinculacion2");
          }
          // this.props.history.push({
          // pathname: "/final-cotizacionbroker",
          // search: `?ramo=${titulo}`,
          // });

        }
      }
    }
  }

  transaccionPendiente() {
    this.setState({ verPagos: false });
  }

  async ObtenerUrlRedireccionar(e, forma) {
    if (forma === "placetopay") {
      this.props.limpiarurlLoading();
      const { ambiente, dpago } = this.state;
      await this.props.obtenerUrlPlacetoPay(
        this.props.dataFacturacion.datosFacturacion.idCarrito,
        ambiente,
        dpago
      );
      if (this.props.datosPago.datosPagar.url !== undefined) {
        window.location.href = this.props.datosPago.datosPagar.url;
      }
    } else if (forma === "debito-automatico") {
      this.props.history.push({
        pathname: "/debito-automatico",
        search: `?id=${this.props.dataFacturacion.datosFacturacion.idCarrito}`,
      });
    }
  }

  async componentDidMount() {
    console.log("Iniciar Forma de Pago");
    await this.props.listarBancosCuotas();

    console.log("porpsdata", this.props.datosCotizacion);
    const queryParams = new URLSearchParams(this.props.location.search);
    let idCarrito = queryParams.get("id");
    //Cargar la información del carrito
    if (idCarrito && idCarrito !== "") {
      let datosJSON = {
        empresa: empresa,
        plataforma: plataformaWeb,
        idCarrito: idCarrito,
      };
      await this.props.datosFacturacion(datosJSON);

      // limpiar loading
      this.props.limpiarurlLoading();

      // Reiniciar datos de pago
      await this.props.validarPagoPendiente(
        this.props.dataFacturacion.datosFacturacion.idCarrito
      );
      this.setState({
        dpago: this.props.datosPago.datosPagar,
        verPagos: this.props.datosPago.datosPagar.pagopendiente,
      });

      // buscar el carrito correspondiente a la poliza actual
      // await this.props.listarCarrito(this.props.datosCarrito.productosCarrito.idCarrito);
      await this.props.listarCarrito(idCarrito);

      this.setState({ ultimosDigitos: this.props.datosCarrito.productosCarrito.ultimosDigitos })

      //Agregado para formas de pago adicionales
      await this.props.listarFormasPago({
        empresa: empresa,
        idUsuario: this.props.dataUsuario.cliCodigoCore,
        // idUsuario: this.props.datosCarrito.productosCarrito.cliCodigoCore,
        //"ambiente": this.props.dataFacturacion.datosFacturacion.ambiente
        ambiente: ambienteAplicacion,
        idCarrito: this.props.dataFacturacion.datosFacturacion.idCarrito,
      });

      // limpiar busqueda de usuario FV
      await this.props.limpiarBusquedaUsuarioFV(null);

      // reiniciar datos cotizacion
      await this.props.getDatosCliente(this.props.datosCarrito.productosCarrito.cliCodigoCore);


      // Reiniciar datos de pago
      // const datosPagador = datosPagadorFormato(this.props.datosCotizacion.datosPagador);
      // const datosFacturacion = datosPagadorFormato(this.props.datosCotizacion.datosPagador);
      // const datosJSONGuardar = {        
      //   empresa: empresa,
      //   plataforma: plataformaWeb,
      //   datosContratante: datosPagador,
      //   datosPagadorFacturacion: datosFacturacion,
      //   idCarrito: this.props.datosCarrito.productosCarrito.idCarrito,
      //   ambiente: ambienteAplicacion,
      // };
      // await this.props.guardarDatos(datosJSONGuardar);  

      //Agregado para formas de pago adicionales----
      this.onValidFormaPagoTipoCotizador();
      this.setState({ loadign: false });
    }
  }


  render() {
    console.log('testing_one_one', this.props);
    const { verPagos, loadign } = this.state;
    const { datosCarrito } = this.props;
    const prodCarrito = datosCarrito.productosCarrito;
    let obtenerUrlPlacetoPayIsLoading = this.props.datosUrl.obtenerUrlPagoIsLoading ? this.props.datosUrl.obtenerUrlPagoIsLoading : false;

    return (
      <LoadingScreen
        loading={obtenerUrlPlacetoPayIsLoading || loadign || this.props.formularioVinculacion.usuarioFvLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={
          obtenerUrlPlacetoPayIsLoading
            ? "Redireccionando..."
            : "Guardando....."
        }
      >
        <Growl ref={(el) => (this.growl = el)} style={{ top: "100px" }} />
        <Page
          title="Forma de Pago"
          breadcrumbs={[{ name: "forma de pago", active: true }]}
        >
          <div className="container-step">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step">
                  {" "}
                  <span>1. Renovación</span>{" "}
                </div>
                <div className="step">
                  {" "}
                  <span>2. Resumen</span>{" "}
                </div>
                <div className="step">
                  {" "}
                  <span>3. Confirmación</span>{" "}
                </div>
                <div className="step current">
                  {" "}
                  <span>4. Forma de Pago</span>{" "}
                </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>

          {verPagos !== undefined && verPagos !== "" && verPagos && (
            <Card className="flex-row">
              <CardBody>
                <Row>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <h2 className="btn-color-main"> Transacción Pendiente</h2>
                    <h5 style={{ textAlign: "justify" }}>
                      Estimado cliente, al momento posee una transacción
                      pendiente.
                    </h5>
                    <h5 style={{ textAlign: "justify" }}>
                      Referencia #:{" "}
                      {this.props.datosPago.datosPagar.referencia === undefined
                        ? ""
                        : this.props.datosPago.datosPagar.referencia}
                    </h5>
                    <h5 style={{ textAlign: "justify" }}>
                      ¿Desea continuar con el pago?
                    </h5>
                    <Button onClick={this.transaccionPendiente}>
                      CONTINUAR
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          )}

          {verPagos !== undefined && !verPagos && (
            <Card className="flex-row">
              <CardBody>
                <Row>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <h2  className="btn-color-main"> PAGO</h2>
                    <h5 style={{ textAlign: "justify" }}>
                      A continuación selecione una forma de pago para continuar.
                    </h5>
                    <h5 style={{ textAlign: "justify" }}>
                      {" "}
                      El valor final que será pagado es:{" "}
                      <strong>
                        ${" "}
                        {this.props.dataFacturacion.datosFacturacion
                          .carValoresTotales &&
                          this.props.dataFacturacion.datosFacturacion
                            .carValoresTotales.primaTotal &&
                          this.props.dataFacturacion.datosFacturacion
                            .carValoresTotales.primaTotal !== null
                          ? this.props.dataFacturacion.datosFacturacion
                            .carValoresTotales.primaTotal
                          : "0.00"}
                      </strong>
                      
                    </h5>
                  </Col>
                </Row>
                {console.log('datosUrl', this.props.datosUrl, typeof (verPagos))}
                {this.props.datosUrl !== undefined &&
                  this.props.datosUrl.msgUrlPago && (
                    <Row>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <Alert color="warning">
                          <center>
                            <p>
                              {`No se pudo procesar el pago correctamente. Por favor intenta nuevamente presionando el botón PAGAR EN LÍNEA`}
                            </p>
                          </center>
                        </Alert>
                      </Col>
                    </Row>
                  )}
              </CardBody>
            </Card>
          )}

          {/* "Agregar para otras formade pago adicionales" */}
          {verPagos !== undefined &&
            !verPagos &&
            this.props.datosFormasPago.FormasPago !== undefined &&
            this.props.datosFormasPago.FormasPago !== " " &&
            this.props.datosFormasPago.FormasPago && // asegurarse que sea objeto, antes de hacer object keys
            Object.keys(this.props.datosFormasPago.FormasPago).length !== 0 &&
            //this.props.datosFormasPago.FormasPago.map((forma) => {
            this.state.FormasPago.length !== 0 &&
            this.state.FormasPago.map((forma) => {
              return (
                <Card className="flex-row">
                  <CardBody className="d-flex justify-content-center flex-column">
                    <Row>
                      {forma.formImagen.length > 1 && (
                        <React.Fragment>
                          {/* <Col lg={4} md={12} sm={12} xs={12} style={{marginBottom:"0em"}}>                                 

                                  <a href="https://www.placetopay.com" target="_blank">
                                    <CardImg
                                      src={forma.formImagen[0]}                          
                                    />
                                  </a>                                 
                                </Col>                                
                                <Col lg={4} md={12} sm={12} xs={12} style={{marginBottom:"0em"}}> 
                                    <Row>
                                      <Col lg={6} md={6} sm={6} xs={12}> 
                                        <CardImg
                                            src={forma.formImagen[1]}
                                          />
                                      </Col>
                                      <Col lg={6} md={6} sm={6} xs={12}> 
                                        <CardImg
                                          src={forma.formImagen[2]}
                                        />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col lg={6} md={6} sm={6} xs={12}> 
                                        <CardImg
                                          src={forma.formImagen[3]}
                                        />
                                      </Col>
                                      <Col lg={6} md={6} sm={6} xs={12}> 
                                        <CardImg
                                            src={forma.formImagen[4]}
                                          />
                                      </Col>
                                    </Row>
                                </Col>   */}
                          <Col
                            lg={8}
                            md={12}
                            sm={12}
                            xs={12}
                            style={{ marginBottom: "0em" }}
                          >
                            <CardImg src={forma.formImagen[0]} />
                          </Col>
                        </React.Fragment>
                      )}
                      {forma.formImagen.length === 1 && (
                        <Col
                          lg={8}
                          md={12}
                          sm={12}
                          xs={12}
                          style={{ marginBottom: "0em" }}
                        >
                          <CardImg src={forma.formImagen[0]} />
                        </Col>
                      )}
                      <Col
                        lg={4}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ marginBottom: "0em" }}
                      >
                        <div style={{ textAlign: "center" }}>
                          <h2  className="btn-color-main">
                            {" "}
                            {forma.formNombre}
                          </h2>
                          <h5 style={{ textAlign: "justify" }}>
                            {" "}
                            {forma.fomrDescripcion}.
                          </h5>
                          <i className="fa fa-arrow-down" aria-hidden="true" />
                          <hr></hr>

                          {console.log('datosCarrito', this.props.datosCarrito, prodCarrito.carDescripcionSeguro)}

                          {/* Suscripcion Tarjeta para pago en linea, aplica para todos*/}
                          {forma &&
                            forma.formCodigo === 'suscripcion' &&
                            prodCarrito.carDescripcionSeguro === 'KilometroPaquete' && (
                              <div>
                                <Button
                                  onClick={(evt) =>
                                    /* this.SuscripcionTarjetaP2P(
                                      evt,
                                      forma.formCodigo
                                    ) */
                                    this.openModal(true)
                                  }
                                >
                                  <i
                                    className="fa fa-credit-card"
                                    aria-hidden="true"
                                  />{" "}
                                  {forma.formNombre}
                                </Button>

                                <Modal
                                  isOpen={this.state.openModal}
                                  toggle={() => this.openModal(false)}
                                  size="lg"
                                >
                                  <ModalHeader toggle={() => this.openModal(false)}>
                                    Seleccione una opción
                                  </ModalHeader>
                                  <ModalBody>
                                    <h4 style={{ fontWeight: "bold" }}>Diferido</h4>
                                    <p />

                                    <Row>


                                      <Col lg={6} md={6} sm={6} xs={12}>
                                        <h5 style={{ fontWeight: "bold" }}>Seleccione el banco emisor de su tarjeta</h5>
                                      </Col>
                                      <Col lg={6} md={6} sm={6} xs={12}>
                                        <Select1
                                          options={listSlct1(this.props.datosBancosCuotas.bancosCuotas)}
                                          value={this.state.bancoSeleccionado}
                                          placeholder={'Seleccione una opción'}

                                          onChange={
                                            (value, e) => {
                                              this.handleChangeBanco(value)
                                            }
                                          }


                                        />

                                        {this.state.errorFormularioBancos && this.state.submitFormularioBancos &&
                                          <Alert color="danger" style={{ marginTop: '10px' }}>
                                            Seleccione una opción
                                          </Alert>
                                        }


                                      </Col>
                                    </Row>
                                    <br />

                                    <Row>


                                      <Col lg={6} md={6} sm={6} xs={12}>
                                        <h5 style={{ fontWeight: "bold" }}>Seleccione los meses a diferir</h5>

                                        {this.state.arrayCuotas.length == 1 &&
                                          <Alert color="warning">

                                            <strong>
                                              {
                                                "Su banco permite el pago únicamente en corriente"
                                              }
                                            </strong>

                                          </Alert>
                                        }

                                      </Col>
                                      <Col lg={6} md={6} sm={6} xs={12}>
                                        <Select1
                                          value={this.state.cuotaSeleccionada}
                                          options={this.state.arrayCuotas}
                                          placeholder={'Seleccione una opción'}
                                          searchable={false}
                                          onChange={
                                            (value, e) => {
                                              this.handleChangeCuotas(value)
                                            }
                                          }
                                        />

                                        {this.state.errorFormularioCuotas && this.state.submitFormularioBancos &&
                                          <Alert color="danger" style={{ marginTop: '10px' }}>
                                            Seleccione una opción
                                          </Alert>
                                        }
                                      </Col>
                                    </Row>

                                    <br />

                                    {this.state.ultimosDigitos != "" &&

                                      <Row>

                                        <Col lg={6} md={6} sm={6} xs={12}>
                                          <h5 style={{ fontWeight: "bold" }}>
                                            {`¿Desea utilizar la tarjeta que termina en ${this.state.ultimosDigitos}?`}
                                          </h5>
                                        </Col>
                                        <Col lg={6} md={6} sm={6} xs={12}>

                                          <Checkbox
                                            id={"agreement"} // Optional.[String].Default: "".  Input ID.
                                            name={"agreement"} // Optional.[String].Default: "". Input name
                                            value={this.state.utilizarMismaTarjeta} // Required.[String].Default: "".
                                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                            checked={this.state.utilizarMismaTarjeta} // Required.[Bool].Default: false.
                                            onChange={(utilizarMismaTarjeta, e) => {

                                              this.setState({
                                                utilizarMismaTarjeta,

                                              });
                                              //console.log(e);
                                            }} // Required.[Func].Default: () => {}. Will return the value.
                                            validationOption={{
                                              name: "agreement", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                              required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            }}
                                          />
                                        </Col>


                                      </Row>


                                    }
                                  </ModalBody>
                                  <ModalFooter>
                                    <Button color="secondary" onClick={() => this.submitFormulario(forma.formCodigo)}>
                                      Guardar
                                    </Button>
                                    <Button color="secondary" onClick={() => this.openModal(false)}>
                                      Cerrar
                                    </Button>
                                  </ModalFooter>
                                </Modal>
                              </div>

                            )
                          }

                    



                          {/* Usuarios no cliente pago en linea */}
                         {/*  {forma &&
                            forma.formCodigo === "placetopay" &&
                            prodCarrito.carDescripcionSeguro !== 'KilometroPaquete' &&
                            prodCarrito.carDescripcionSeguro !== 'ACCIDENTES PERSONALES ABIERTO' &&
                            prodCarrito.carDescripcionSeguro !== 'FULL COBERTURA' &&
                            prodCarrito.carDescripcionSeguro !== 'AIG AUTO' &&
                            this.props.dataUsuario.usu_tipo_usuario !==
                            "cliente" && (
                              <Button
                                onClick={(evt) =>
                                  this.SeleccionarFormaPago(
                                    evt,
                                    forma.formCodigo,
                                    false
                                  )
                                }
                              >
                                <i
                                  className="fa fa-credit-card"
                                  aria-hidden="true"
                                />{" "}
                                {forma.formNombre}
                              </Button>
                            )
                          } */}

                          {/* Usuarios si cliente pago en linea y debito */}
                          {((forma &&
                            forma.formCodigo === "placetopay" &&
                            prodCarrito.carDescripcionSeguro !== 'KilometroPaquete' &&
                            this.props.dataUsuario.usu_tipo_usuario ===
                            "cliente") ||
                            forma.formCodigo === "debito-automatico") && (
                              <Button
                                onClick={(evt) =>
                                  this.ObtenerUrlRedireccionar(
                                    evt,
                                    forma.formCodigo
                                  )
                                }
                              >
                                <i
                                  className="fa fa-credit-card"
                                  aria-hidden="true"
                                />{" "}
                                {forma.formNombre}
                              </Button>
                            )}

                          {/* casos no pago en linea ni debito */}
                          {forma &&
                            (forma.formCodigo !== "suscripcion" || forma.formCodigo === "placetopay" ) &&
                      
                            forma.formCodigo !== "debito-automatico" && (
                              <Button
                                onClick={(evt) =>
                                  this.SeleccionarFormaPago(
                                    evt,
                                    forma.formCodigo,
                                    false
                                  )
                                }
                              >
                                <i
                                  className="fa fa-credit-card"
                                  aria-hidden="true"
                                />{" "}
                                {forma.formNombre +" "}
                              </Button>
                            )}
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              );
            })}
          {/* "FIn de Agregar para otras formade pago adicionales" */}
        </Page>


      </LoadingScreen>
    );
  }

  irAFormularioVinculacion = async () => {
    await this.props.consultarFv({ content: '', id: this.props.dataFacturacion.datosFacturacion.idCarrito });
    const { transaccion, pasarPantallaFormulario, urlFormulario } = this.props.formularioVinculacion.usuarioFv;
    console.log('testingd', this.props.formularioVinculacion);
    if (transaccion) {
      let titulo = '';
      if (pasarPantallaFormulario) {
        this.props.history.push({
          pathname: "/formulario-vinculacion-renovacion",
          search: `?url=${urlFormulario}&id=${this.props.dataFacturacion.datosFacturacion.idCarrito}`,
        });
      }
      else {
        const descripcionRamo = this.props.dataFacturacion.datosFacturacion.carDescripcionRamo;
        const descripcionSeguro = this.props.dataFacturacion.datosFacturacion.carDescripcionSeguro;
        titulo = getTituloFv(descripcionRamo, descripcionSeguro);
        console.log("/formulario-vinculacion1");
        this.props.history.push({
          pathname: "/formulario-vinculacion-renovacion",
          search: `?haveForm=${titulo}`,
        });
        console.log("/formulario-vinculacion2");
      }
    }
  }

  showWarn = (message, severity) => {
    this.growl.show({
      sticky: true,
      severity: severity,
      summary: "Información",
      detail: message,
    });
  };

  handleChangeBanco = (valor) => {
    const { datosBancosCuotas, } = this.props;
    const planes = this.props.datosCarrito.productosCarrito.carProductos[0].PlanesKmPaquete
    const planActual = this.props.datosCarrito.productosCarrito.carProductos[0].datosCalculoScoring.plan

    const planSeleccionado = planes.find(plan => plan.codigo == planActual.split(' ')[0])

    const diferidos = datosBancosCuotas.bancosCuotas.find(banco => banco.id == valor.value).cuotas
    console.log('verData: ', planSeleccionado)
    this.setState({
      bancoSeleccionado: valor,
      cuotas: 1,
      codigoBanco: valor.value,
      arrayCuotas: listSlct1Cuotas(diferidos, planSeleccionado),
      errorFormularioBancos: false

    })
  }

  /**
   * 
   * @param {*} valor valor seleccionado en el dropdown cuotas
   * Acción al seleccionar un elemento en el dropdown de cuptas
   */
  handleChangeCuotas = (valor) => {
    this.setState({
      cuotaSeleccionada: valor,
      cuotas: parseInt(valor.value),
      errorFormularioCuotas: false

    })
  }

  onValidFormaPagoTipoCotizador = () => {
    if (
      this.props.dataFacturacion &&
      this.props.dataFacturacion.datosFacturacion &&
      this.props.dataFacturacion.datosFacturacion.carDescripcionSeguro
    ) {
      this.setState({
        tipoCotizador: this.props.dataFacturacion.datosFacturacion
          .carDescripcionSeguro,
      });
    }
    if (this.props.datosFormasPago && this.props.datosFormasPago.FormasPago) {
      this.setState({
        FormasPago: this.props.datosFormasPago.FormasPago,
      });
    }
    /*if (
      this.state.tipoCotizador != null &&
      this.state.tipoCotizador === "KilometroConsumidos"
    ) {
      this.setState({
        FormasPago: this.state.FormasPago.filter(
          (c) => c.formCodigo === "placetopay"
        ),
      });
    }*/
  };
}

/**
 * 
 * @param {*} list lista inicial
 * @returns  Lista formateada para utilizar en Select1
 */
const listSlct1 = (list) => {
  console.log('list', list)
  const formatList = []
  for (const idx in list) {

    formatList.push({
      value: list[idx]['id'],
      label: list[idx]['nombre']
    })
  }

  // return
  return formatList
}

/**
  * 
  * @param {*} list lista inicial
  * @returns  Lista formateada para utilizar en Select1
  */
const listSlct1Cuotas = (list, planSeleccionado) => {

  const numeroMeses = planSeleccionado.vigenciaMeses.split(' ')[0];

  console.log('planSeleccionado', numeroMeses)
  console.log('list', list)
  const formatList = []

  list.forEach(element => {

    if (element <= numeroMeses) {
      formatList.push({
        value: element,
        label: element == 1 ? '1 mes (Pago corriente)' : element + ' meses'
      })
    }

  });


  // return
  return formatList
}

const mapStateToProps = (state) => ({
  datosCarrito: state.dataProductoCarrito,
  datosPago: state.datosPago,
  dataUsuario: state.datosUsuarios.dataUsuario,
  datosUrl: state.datosObtenerUrlPlaceToPay,
  datosFormasPago: state.datosFormasPago,
  datosGuardarFormaPago: state.datosGuardarFormaPago,
  datosCotizacion: state.datosCotizacion,
  formularioVinculacion: state.rFormularioVinculacion,
  placetoPay: state.rPlaceToPay,
  //Obtener datos de un servicio comun
  dataFacturacion: state.dataFacturacion,
  datosBancosCuotas: state.dataBancosCuotas,
});

const mapDispatchToProps = (dispatch) => {
  return {
    validarPagoPendiente: (idCarrito) =>
      dispatch(FetchValidarPagoPendiente(idCarrito)),
    obtenerUrlPlacetoPay: (idCarrito, ambiente, dpago) =>
      dispatch(FetchObtenerUrlPlacetoPay(idCarrito, ambiente, dpago)),
    limpiarurlLoading: () => dispatch(FetchLimpiarUrlPlacetoPay()),
    listarFormasPago: (datos) => dispatch(FetchObtenerFormasPago(datos)),
    listarCarrito: (idCarrito) =>
      dispatch(FetchDataProductosCarrito(idCarrito)),
    guardarFormaPago: (datos) => dispatch(FetchGuardarFormaPagoRenovaciones(datos)),
    suscripcionP2P: (datos) => dispatch(suscripcionExternaTarjetaP2P(datos)),
    //ObtenerInformacion de un servicio comun para obtener la información del carrito
    datosFacturacion: (data) => dispatch(recuperarDatosFacturacionFetch(data)),
    limpiarBusquedaUsuarioFV: () => dispatch(setConsultarUsuarioFv(null)),
    consultarFv: (data) => dispatch(consultarUsuarioFV(data)),
    getDatosCliente: idCliente => dispatch(obtenerDatosClienteFetch(idCliente)),
    guardarDatos: (datos) => dispatch(FetchGuardarDatosFacturacion(datos)),
    listarBancosCuotas: () => dispatch(FetchDataBancosCuotas()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CotizacionFormaPago)
);
